import { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { TrendingUp } from "lucide-react";

const label = (k) => new Date(`${k}-01`).toLocaleDateString("en-IN", { month: "short", year: "2-digit" });

export default function CollectionTrend() {
  const [data, setData] = useState([]);
  useEffect(() => { api.get("/reports/trend", { params: { months: 12 } }).then((r) => setData(r.data.map((d) => ({ ...d, name: label(d.month) })))).catch(() => {}); }, []);
  const best = data.reduce((m, d) => (d.collection > (m?.collection ?? -1) ? d : m), null);

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5" data-testid="collection-trend">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <h3 className="font-head font-semibold flex items-center gap-2"><TrendingUp className="h-4 w-4 text-teal-600" /> Collection Trend · last 12 months</h3>
        {best && best.collection > 0 && <span className="text-xs text-slate-500">Best month: <b className="text-slate-800">{best.name}</b> ({formatINR(best.collection)})</span>}
      </div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <CartesianGrid vertical={false} stroke="#e2e8f0" />
            <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} tickFormatter={(v) => (v >= 1000 ? `${Math.round(v / 1000)}k` : v)} width={40} />
            <Tooltip cursor={{ fill: "#f1f5f9" }} formatter={(v, n) => (n === "collection" ? [formatINR(v), "Collection"] : [v, "Patients"])} labelStyle={{ color: "#0f172a" }} contentStyle={{ borderRadius: 12, border: "1px solid #e2e8f0" }} />
            <Bar dataKey="collection" fill="#0d9488" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
